module.exports = __webpack_public_path__ + "b1cac39e5d0ab57880fb908f110e67d0.jpg";